import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import From from '../../components/controls/Form';
import { IS_JEST, DEV_MODE } from '../../utils/Constants';
import { faker } from '@faker-js/faker';
import Heading from '../../components/controls/Typography/Heading';
import { TextParagraph } from '../../components/controls/Typography/TextBody';

import './errorMessage.less';
/**
 *
 * @param {{ title?:string; icon?:string; errorMessage1?:string; errorMessage2?:string; }} props
 * @returns
 */
export const FormError = (props) => {
  const {
    icon = null,
    errorMessage1 = null,
    errorMessage2 = null
  } = props
  return (
    <From
      icon={<i className={'far fa-lg ' + icon + ''}></i>}
      isNarrow
      hasBorder
    >
      <TextParagraph className="text-center">{errorMessage1}</TextParagraph>
      <TextParagraph className="text-center">{errorMessage2}</TextParagraph>
    </From>
  );
}

export const ErrorMessagePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    title = null,
    icon = null,
    errorMessage1 = null,
    errorMessage2 = null
  } = location.state ?? (IS_JEST || DEV_MODE ? {
    title: faker.lorem.words(4),
    icon: 'fa-hourglass-end',
    errorMessage1: faker.lorem.sentences(2),
    errorMessage2: faker.lorem.sentences(3)
  } : {});

  useEffect(() => {
    document.title = 'Letters Portal - Guest Access';
    IS_JEST || DEV_MODE || title ? void 0 : navigate('/notFound');
  }, []);

  return (<main className="lsn-page lsn-page-error-message">
    <Heading className="text-center no-focus-outline" tabIndex={0}>
      {title}
    </Heading>
    <FormError
      icon={icon}
      errorMessage1={errorMessage1}
      errorMessage2={errorMessage2}
    />
  </main>
  );
};

export default ErrorMessagePage;
